
<template>
<div class="form-container">
  <div class="form-region form-order">
	   <com-page-title></com-page-title>
	   <div style="display: flex;background: rgb(244, 244, 244)!important;align-items: center;" class="mb-4 p-3">
	   	<div   style="width:120px;height: 120px;margin-right: 80px;" class="avatar " >
	   	     <el-avatar  class="avatar-f no-bg"  :size="120" :src="form.avatarUrl"><img   src="~@/assets/xiazs.jpg"  /> </el-avatar>
	   	<span class="avatar-edit text-white el-dropdown-link f12" style="display: block;width: 120px;">{{form.nickName||'昵称'}}</span>
	   	   </div>
	   		     <el-descriptions   size="medium" style="display: flex;width: 50%;background: rgb(244, 244, 244)!important;"  class="pt-1" title="" :column="2" >
					<!-- <el-descriptions-item v-if="form.groups==20" label="活动名称">{{title||''}}</el-descriptions-item> -->
	   		       <el-descriptions-item label="编码">{{form.code||'自动生成'}}</el-descriptions-item>
	   		       <el-descriptions-item label="创建时间">{{form.createTime||'自动生成'}}</el-descriptions-item>
	   			   <el-descriptions-item label="手机号">{{form.recTel}}</el-descriptions-item>
	   		        <el-descriptions-item label="地址">{{form.recAddress}}</el-descriptions-item>
					<el-descriptions-item label="支付号">{{form.payCode}}</el-descriptions-item>
	   		     </el-descriptions>
	   	</div>
		
		 <el-form  v-if="form.id" ref="forms" :model="form" label-width="160px">
			 <el-form-item   required  label='状态'>
			 <el-radio-group  :disabled="status==100" v-model="form.status">
			 	<el-radio v-if="status!=100" :label="10">待支付</el-radio>
			 	<el-radio v-if="status!=100" :label="20">已支付</el-radio>
			 	<el-radio  v-if="status!=100" :label="30">待收货</el-radio>
				<el-radio  v-if="status!=100"  :label="40">已完成</el-radio>
			 	<el-radio   v-if="status!=100" :label="100">已退款</el-radio>
			 </el-radio-group>
			  </el-form-item>
			  <el-form-item v-if="status!=100">
			    <el-button type="primary" @click="onSubmit">立即提交</el-button>
			  </el-form-item>
			  <!--  <com-form-title  v-if="status==20"  title="物流信息"></com-form-title>
			  <el-form-item v-if="status==20" label="物流名称">
			  	<el-input placeholder='请填写' maxlength='20'  show-word-limit clearable 
			  		v-model="form.wayName"></el-input>
			  </el-form-item>
			  <el-form-item v-if="status==20" label="物流单号">
			  	<el-input placeholder='请填写' maxlength='20'  show-word-limit clearable 
			  		v-model="form.wayCode"></el-input>
			  </el-form-item>
			  <el-form-item v-if="status==20">
			    <el-button type="primary" @click="onSubmits">立即提交</el-button>
			  </el-form-item> -->
			  
			  
			  <template v-if="form.status==20">
			    <com-form-title    title="售后信息"></com-form-title>
			 <!-- 	<el-form-item required label='售后' v-if="form.afterStatus>0">
			  		<el-radio-group :disabled="status==100" v-model="form.afterStatus">
			  			<el-radio v-if="status!=100" :label="10" :disabled="form.afterStatus>0?true:false">待处理</el-radio>
			  			<el-radio v-if="status!=100" :label="20" :disabled="form.afterStatus>0?true:false">已处理</el-radio>
			  		</el-radio-group>
			  	</el-form-item> -->
			  	<el-form-item required label="申请退款说明">
			  		<el-input type='textarea' placeholder='请填写' maxlength='500' :disabled="true"
			  			show-word-limit clearable v-model="form.afterRemarks">
			  		</el-input>
			  	</el-form-item>
			  	<el-form-item required label="退款金额">
			  		<el-input placeholder='请填写' maxlength='20' :disabled="form.afterStatus>10?true:false" clearable
			  			v-model="form.afterRefund">
			  		</el-input>
			  	</el-form-item>
			  	<el-form-item  required label="客服备注">
			  		<el-input type='textarea' placeholder='请填写' maxlength='200' :disabled="form.afterStatus>10?true:false" clearable
			  			v-model="form.afterMessage">
			  		</el-input>
			  	</el-form-item>
			  	<el-form-item v-if="form.afterStatus<20">
			  		<el-button type="primary" @click="onSubmitsAfter" >立即提交</el-button>
			  	</el-form-item>
			  </template>
			 </el-form>
			    <com-form-title    title="基本信息"></com-form-title>
 <el-form :class="$store.state.operate=='详情'?'form-disabled':''" :disabled="$store.state.operate=='详情'"  ref="form" :model="form" label-width="160px">

	<el-form-item required label="姓名">
		<el-input placeholder='请填写' maxlength='20' :disabled="form.id?true:false" show-word-limit clearable 
			v-model="form.recName"></el-input>
	</el-form-item>
	<el-form-item required label="电话">
		<el-input placeholder='请填写' maxlength='20' :disabled="form.id?true:false" show-word-limit clearable type="number"
			v-model="form.recTel"></el-input>
	</el-form-item>
	
	<com-form-region :disabled="form.id?true:false" v-model="form.recAddress"></com-form-region>
	<el-form-item required label="详细地址">
		<el-input placeholder='请填写' maxlength='200'  :disabled="form.id?true:false" show-word-limit clearable 
			v-model="form.recAddressx"></el-input>
	</el-form-item>
		 <el-form-item  label='备注'>
		<el-input  type='textarea' v-model='form.remarks' :disabled="form.id?true:false" maxlength='50' show-word-limit clearable></el-input>
		 </el-form-item>
		
		<com-form-title    title="产品信息"></com-form-title>
		<el-form-item required  label='' v-if="form.groups!=20">
			<el-table :data="itemList" class="" highlight-current-row style="width: 100%;">
				<template slot="empty">
					<el-empty description="暂时没有数据"></el-empty>
				</template>
			<el-table-column width="200" prop='title' label='名称' ></el-table-column>
			  <com-page-imgurl  column='imgurl' title='图片' ></com-page-imgurl>
			   <el-table-column prop='price' label='价格' ></el-table-column>
			    <el-table-column prop='afterQuantity' label='退款数量' ></el-table-column>
						<el-table-column prop='quantity' label='数量' >
							<template slot-scope="scope">
											<el-input v-int type="number" :disabled="true" @blur="quantityBlur(scope.row)" size="mini" v-model="scope.row.quantity" controls-position="right" :min="0" ></el-input >
							</template>
						</el-table-column>
						 <el-table-column prop='costPrice' label='金额' >
							 <template slot-scope="scope">
								 <div>{{scope.row.quantity*scope.row.price}}</div>
							 </template>
						 </el-table-column>
						 <el-table-column
						   prop="stock" 
						   label="库存">
						   <template slot="header" slot-scope="scope">
						   				 <el-button @click="openSpu=true" v-if="!form.id" type="text" >添加</el-button>
						   </template>
						   <template slot-scope="scope">
						   				<el-link v-if="!form.id" @click="itemList.splice(scope.$index,1)" :underline="false" size="mini"  class="text-danger">删除</el-link>
						   </template>
						 </el-table-column>
			</el-table>
			
			</el-form-item>
   <el-form-item v-if="!form.id">
     <el-button type="primary" @click="onSubmit">立即提交</el-button>
   </el-form-item>
 </el-form>
 </div>
</div>
</template>
<script>
  export default {
	  props: {
	  	id: {//主键id
	  		type: String,
	  		default: ''
	  	}
	  },
  data() {
  return {
    dateRange:[],//表单限制日期
	openSpu:false,
	itemList:[],
	status:'',
	title:'',//活动名称
  form: {
	id:'',//Id
		code:'',//编码
		codeExt:'',//编码扩展
		groups:'',//分组扩展
		types:'',//类型扩展
		status:'',//状态
		createTime:'',//创建时间
		recName:'',//联系人
		recTel:'',//手机号
		recZip:'',//邮编扩展
		recProvince:'',//省扩展
		recCity:'',//市扩展
		recArea:'',//区扩展
		recStreet:'',//街道扩展
		recAddress:'',//地址
		recAddressx:'',//详细地址
		recTime:'',//时间扩展
		recExt:'',//扩展
		wayTime:'',//发货时间扩展
		wayName:'',//发货名称扩展
		wayCode:'',//发货编码扩展
		wayCost:'',//发货费用扩展
		payTime:'',//支付时间扩展
		payCode:'',//支付编码扩展
		payName:'',//支付名称扩展
		payNo:'',//支付号扩展
		costPrice:'',//订单金额
		tolCost:'',//实际支付金额
		couponId:'',//卡券编号扩展
		couponCost:'',//卡券金额扩展
		couponTitle:'',//卡券名称扩展
		score:'',//消耗积分扩展
		scoreCost:'',//积分兑换金额扩展
		discount:'',//折扣优惠扩展
		brief:'',//扩展
		title:'',//扩展
		finishTime:'',//完成时间扩展
		cancelTime:'',//取消时间扩展
		invoiceId:'',//发票Id扩展
		invoice:'',//发票扩展
		afterStatus:'',//扩展状态
		afterTime:'',//售后时间扩展
		afterDate:'',//售后处理时间扩展
		afterMessage:'',//售后留言扩展
		afterRemarks:'',//售后备注扩展
		afterRefund:'',//售后退款扩展
		remarks:'',//备注
		platform:'',//来源信息扩展
		imgurlArray:'',//图片组
		extFlag:'',//扩展
		extMore:'',//扩展
		ext:'',//扩展
		createName:'',//商家名称
		createId:'',//商家Id扩展
		nickName:'',//头像
		avatarUrl:'',//昵称
		userId:'',//
		counts:'',//
  }
  }
  },
  methods: {
	  onSubmitsAfter() {
	  	if (!this.form.afterRefund) {
	  		this.$message.error('请填写退款金额');
	  		return;
	  	}
	  	this.$axios.post('/api/Orders/PostOrdersRefundResult', {
	  		id: this.form.id,
	  		afterStatus: 20,
	  		afterRefund: this.form.afterRefund,
	  		afterMessage: this.form.afterMessage
	  	}).then(e => {
	  		this.$message.success('提交成功同步到服务器');
	  	});
	  },
	  onSubmits(){
		  if(!this.form.wayName){this.$message.error('请填写物流名称');return ;}
		   if(!this.form.wayCode){this.$message.error('请填写物流单号');return ;}
		  this.$axios.post('/api/Orders/PostOrdersWay',{id:this.form.id,wayName:this.form.wayName,wayCode:this.form.wayCode}).then(e => {
		  		    this.$message.success('提交成功同步到服务器');
		   });
	  },
	  downloadClick(){
		  this.$confirm("您确认要导出当前订单吗", "操作提示", {
		  	type: 'warning'
		  }).then(() => {
		   this.$axios.post(`/api/Orders/PostOrdersExcel`,JSON.stringify(this.form.id.toString())).then(e => {
			 	window.location.href=this.$domain+e.data;
			   })
		  
		  }).catch(() => {});
	  },
	  quantityBlur(e){
		  if(e.quantity>e.stock)e.quantity=e.stock;
		   if(e.quantity==0)e.quantity=1;
	  },
	  callbackSpu(e){
		  console.log(e)
		  if(e.length>0){
			var index=  this.itemList.findIndex(item=>item.skuId==e[0].id);
			 if(index==-1){
				 this.itemList.push({skuId:e[0].id,spuId:e[0].spuId,quantity:1,price:e[0].price,imgurl:(e[0].paramName||e[0].imgurls),stock:e[0].stock,title:(e[0].title||e[0].titles)})
			 }
		  }
		  this.openSpu=false
	  },
 onSubmit() {//表单提交
 if(this.form.id&&this.status==this.form.status){
	 this.$message.error('当前订单状态无须更改');return ;
 }

	 this.form.id=this.$store.state.operate=='复制'?'':this.id;
 if(!this.form.id){
	 if(!this.form.recName){this.$message.error('请填写姓名');return ;}
	  if(!this.form.recTel){this.$message.error('请填写手机号');return ;}
	   if(!this.form.recAddress){this.$message.error('请选择所在地区');return ;}
	    if(this.form.recAddress.split(',').length<4){this.$message.error('请选择街道');return ;}
		var array=this.form.recAddress.split(',');
		this.form.recProvince=array[0];
		this.form.recCity=array[1];
		this.form.recArea=array[2];
		this.form.recStreet=array[3];
		if(!this.form.recAddressx){this.$message.error('请填写详细地址');return ;}
		 if(this.itemList.length==0){this.$message.error('请添加产品');return ;}
		 this.form.itemList=this.itemList; 
 }
 if(this.form.id){
	 this.$axios.post('/api/Orders/PostOrdersStatus',{id:this.form.id,status:this.form.status}).then(e => {
		 this.status=this.form.status;
		    this.$message.success('提交成功同步到服务器');
	  });
	 return
 }
	 let url=this.form.id?`/api/Orders/PostOrdersUpdate`:`/api/Orders/PostOrdersAppend`;
	 let data=this.form;
 this.$axios.post(url,data).then(e => {
   this.$emit("callbackPage",{statusText:this.form.id?'编辑':'添加'}); 
  });
 }
  },mounted() {//根据id获取表单数据
	  if(this.id){
		  this.$axios.get(`/api/Orders/GetOrders?id=${this.id}`).then(e => {
		   this.form=e;
		   this.status=e.status;
		   this.itemList=e.itemList;
		   this.title=e.title;
		      if(this.$store.state.operate=='复制'){
			    this.$message.success('内容已经复制到表单');
		   }
		  });
	  }
      }
  }
</script>
<style >
	.form-order .el-table__header-wrapper .el-table__cell{
		padding: 0!important;
		height: 40px;
	}
	.expand-table .el-table__expanded-cell{
		padding: 0px!important;
	}
</style>
